var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./VueGoogleAutocomplete.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bde782ba\"}!../../vue-loader/lib/selector?type=template&index=0!./VueGoogleAutocomplete.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-google-autocomplete/src/VueGoogleAutocomplete.vue
// module id = 390
// module chunks = 5